import { useCallback } from "react";
import { ApiActionResponse } from "../../apps/reader/framework/api/core/action-types";
import useMountedState from "./useMountedState";

const useSafeAsync = () => {
  const isMounted = useMountedState();
  const safeAsync = useCallback(
    (promise) => {
      return new Promise<ApiActionResponse>((resolve) => {
        promise.then((value) => {
          if (isMounted()) {
            resolve(value);
          }
        });
      });
    },
    [isMounted]
  );

  return safeAsync;
};

export default useSafeAsync;
